export class CheckboxModel {
  label: string = "";
  checked: boolean = false;

  private _id: string = "";

  get id(): string {
    return this._id == null || this._id == "" ? this.label : this._id;
  }

  set id(newId: string) {
    this._id = newId;
  }

  constructor(id: string, label: string) {
    this.id = id;
    this.label = label;
  }

  toAnswerModel(): AnswersCheckboxModel {
    return new AnswersCheckboxModel(this.id, this.checked);
  }
}

export class AnswersCheckboxModel {
  label: string;
  checked: boolean;

  constructor(label: string, checked: boolean) {
    this.label = label;
    this.checked = checked;
  }
}
